import React from 'react';

interface GoogleLogoSvgProps {
  size?: string;
}

export const GoogleLogoSvg = ({ size = '15px' }: GoogleLogoSvgProps) => (
  <svg
    viewBox="0 0 15 15"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    fill="none"
    height={size}
    width={size}
  >
    <path
      d="M3.32432 9.06465L2.80219 11.0138L0.893819 11.0542C0.323496 9.99638 0 8.78609 0 7.49996C0 6.25628 0.302461 5.08347 0.838594 4.05078H0.839004L2.53799 4.36227L3.28225 6.05105C3.12648 6.50519 3.04157 6.99269 3.04157 7.49996C3.04163 8.05051 3.14136 8.578 3.32432 9.06465Z"
      fill="#FBBB00"
    />
    <path
      d="M14.869 6.09888C14.9551 6.55257 15 7.02111 15 7.49997C15 8.03692 14.9436 8.56069 14.836 9.06592C14.4709 10.7851 13.5169 12.2864 12.1954 13.3487L12.195 13.3483L10.055 13.2391L9.75214 11.3485C10.6291 10.8342 11.3144 10.0294 11.6754 9.06592H7.66492V6.09888H11.7339H14.869Z"
      fill="#518EF8"
    />
    <path
      d="M12.1949 13.3483L12.1953 13.3488C10.91 14.3818 9.27731 15 7.49998 15C4.6438 15 2.16057 13.4036 0.893799 11.0542L3.3243 9.0647C3.95767 10.7551 5.5883 11.9584 7.49998 11.9584C8.32167 11.9584 9.09148 11.7363 9.75203 11.3485L12.1949 13.3483Z"
      fill="#28B446"
    />
    <path
      d="M12.2873 1.72664L9.85758 3.71578C9.17394 3.28846 8.36581 3.0416 7.50003 3.0416C5.54508 3.0416 3.88395 4.30011 3.28231 6.05109L0.839033 4.05082H0.838623C2.08685 1.64423 4.6014 0 7.50003 0C9.31981 0 10.9884 0.648223 12.2873 1.72664Z"
      fill="#F14336"
    />
  </svg>
);

